<template>
  <div
    class="
      tw-bg-white
      tw-rounded-3xl
      tw-px-2
      tw-py-0.5
      tw-gap-2
      tw-inline-flex
      tw-items-center
      tw-border-solid
      tw-border
    "
    :class="[pillClasses, theme.pillText, theme.pillBorder]"
  >
    <slot name="left-icon"></slot>
    <span
      v-if="props.viewingUrl"
      v-tooltip="viewingTooltip"
      data-testid="document-pill-view"
      class="
        tw-font-medium tw-text-[11px] tw-leading-3 tw-cursor-pointer
        hover:tw-text-sf-primary
      "
      @click="handleView"
    >
      <slot></slot>
    </span>
    <span v-else class="tw-font-medium tw-text-[11px] tw-leading-3">
      <slot></slot>
    </span>
    <span v-if="percentage || fileSize" class="tw-opacity-50">
      <span v-if="percentage">
        {{ percentage }}
        <span>{{ I18n.t('components.document.queued_single.of') }}</span>
      </span>
      <span v-if="fileSize">
        {{ formattedBytes }}
      </span>
    </span>
    <div
      v-if="allowDelete"
      class="tw-w-px tw-self-stretch tw--my-0.5"
      :class="theme.pillDivider"
    ></div>
    <i
      v-if="allowDelete"
      v-tooltip="deleteTooltip"
      class="
        sf-pointer
        fa fa-trash
        tw-text-xs tw-leading-4
        hover:tw-text-sf-gray-light
      "
      data-testid="document-pill-delete"
      @click="handleDelete"
    ></i>
  </div>
</template>
<script lang="ts" setup>
import { computed } from 'vue'
import { commsTheme } from '@app/shared/comms-theme'

import { formatBytes } from '@app/utils/file-helpers'
import useI18n from '../composables/use-I18n'

interface Props {
  allowDelete?: boolean
  deleteTooltip?: string
  fileSize?: number
  isDisabled?: boolean
  progress?: number | string
  viewingUrl?: string
  viewingTooltip?: string
}

const theme = commsTheme()

const props = withDefaults(defineProps<Props>(), {
  deleteTooltip: '',
  fileSize: 0,
  isDisabled: false,
  progress: undefined,
  viewingUrl: '',
  viewingTooltip: '',
})

const pillClasses = computed(() => {
  return {
    'sf-btn-disabled tw-text-sf-gray-light': props.isDisabled,
  }
})

const deleteTooltip = computed(() => {
  if (props.deleteTooltip) {
    return props.deleteTooltip
  } else {
    return I18n.t('common.delete_file')
  }
})

const viewingTooltip = computed(() => {
  if (props.viewingTooltip) {
    return props.viewingTooltip
  } else {
    return I18n.t('common.preview_file')
  }
})

const emit =
  defineEmits<{
    delete: []
  }>()

const I18n = useI18n()

const percentage = computed(() => {
  return props.progress ? `${props.progress}%` : null
})

const formattedBytes = computed(() => {
  return formatBytes(props.fileSize)
})

function handleDelete() {
  emit('delete')
}

function handleView() {
  window.open(props.viewingUrl, '_blank')
  return false
}
</script>
